import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function Accessibility() {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid="accessibility-page">
      <Seo
        title="Accessibility & Security | HiredToday"
        description="How HiredToday approaches accessibility, confidentiality and data security."
        path="/accessibility"
      />
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Legal</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black text-zinc-950">
        Accessibility &amp; security.
      </h1>

      <section className="mt-12" data-testid="accessibility-statement">
        <h2 className="font-display text-2xl font-bold text-zinc-950">Accessibility</h2>
        <div className="mt-4 space-y-4 text-sm sm:text-base text-zinc-600 leading-relaxed">
          <p>
            HiredToday is built to be usable by as many people as possible. Pages use semantic headings and
            landmarks, forms are labelled, colour is never the only way information is shown, and the site works
            with keyboard navigation and modern screen readers.
          </p>
          <p>
            If anything on the site is hard for you to use, tell us at
            <a href="mailto:office@hiredtoday.co.uk" className="text-blue-700 font-medium hover:text-blue-900"> office@hiredtoday.co.uk</a> and
            we will fix it or find another way to get you the information.
          </p>
        </div>
      </section>

      <section className="mt-12" data-testid="security-statement">
        <h2 className="font-display text-2xl font-bold text-zinc-950">Confidentiality &amp; security</h2>
        <div className="mt-4 space-y-4 text-sm sm:text-base text-zinc-600 leading-relaxed">
          <p>
            Your account is protected by industry-standard password hashing and encrypted connections (HTTPS).
            Documents you upload, CVs, right-to-work and identity files, are visible only to you and the
            employer you share them with, and are never shown publicly.
          </p>
          <p>
            Payments are handled by Stripe; card details never touch our servers. How we collect, use and retain
            personal data is set out in the <Link to="/privacy" className="text-blue-700 font-medium hover:text-blue-900">privacy policy</Link>,
            and our cookie use in the <Link to="/cookies" className="text-blue-700 font-medium hover:text-blue-900">cookie policy</Link>.
          </p>
          <p>
            To report a security concern, email
            <a href="mailto:office@hiredtoday.co.uk" className="text-blue-700 font-medium hover:text-blue-900"> office@hiredtoday.co.uk</a> with
            "Security" in the subject line.
          </p>
        </div>
      </section>
    </main>
  );
}
